export class PedidoDadosIntegracaoModel {
    constructor(
        public nomeIntegrador: string = '',
        public cnpjIntegrador: string = '',
        public credencialCliente: string | null = null,
        public codigoAplicacao: number = 0
    ) { }
}
